import { Staff } from "./staff";
import { Customer } from "./customer";
import { Opportunity } from "./opportunity";
import { Order } from "./order";
import { Feedback } from "./feedback";
import { Lead } from "./lead";
import { Todo } from "./todo";
import { Comment } from "./comment";
import { Role } from "./role";

export type ActivityLogRefType =
  | "AUTH"
  | "CUSTOMER"
  | "OPPORTUNITY"
  | "ORDER"
  | "FEEDBACK"
  | "LEAD"
  | "TODO"
  | "COMMENT"
  | "STAFF"
  | "ROLE";

export interface ActivityLog {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  description: string;
  refId: number;
  refType: ActivityLogRefType;
  staff: Staff | null;
  customer?: Customer | null;
  opportunity?: Opportunity | null;
  order?: Order | null;
  feedback?: Feedback | null;
  lead?: Lead | null;
  todo?: Todo | null;
  comment?: Comment | null;
  refStaff?: Staff | null;
  role?: Role | null;
}

export type ActivityLogLocationState = {
  customer?: Customer;
  lead?: Lead;
  todo?: Todo;
  feedback?: Feedback;
};

export const activityLogRefTypeLabel: Record<ActivityLogRefType, string> = {
  AUTH: "Đăng nhập",
  CUSTOMER: "Khách hàng",
  OPPORTUNITY: "Cơ hội",
  ORDER: "Đơn hàng",
  FEEDBACK: "Phản hồi",
  LEAD: "Lead",
  TODO: "Việc cần làm",
  COMMENT: "Bình luận",
  STAFF: "Nhân viên",
  ROLE: "Vai trò",
};
